function extractApplicationIdFromUrl(): string | null {
  try {
    return new URL(window.location.href).searchParams.get('applicationId');
  } catch {
    return null;
  }
}

export default extractApplicationIdFromUrl;
